<div class="question-panel">
  <div class="custom-answer__group custom-answer__group--percent form-group mb-0">
    @for (item of items; track item) {
      <div class="custom-answer">
        <div class="custom-answer__title">
          <label>{{item.answer}}</label>
        </div>
        <div class="custom-answer__percent">
          <input type="number" [(ngModel)]="item.percent" (ngModelChange)="onChange()" placeholder="0" class="form-control">
          <span class="custom-answer__percent-indi">%</span>
        </div>
      </div>
    }
  </div>
  <div class="question-panel__total">
    <div class="question-panel__total-name">
      <p>{{footerLabelText}}</p>
    </div>
    <div class="question-panel__total-amount">
      <p>
        <span [ngClass]="{'is-invalid': totalAmount > percentAmount}">{{totalAmount | number}}</span> of {{percentAmount}}
      </p>
      <span class="question-panel__total-indi"> % </span>
    </div>
  </div>
</div>
